var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      style: {
        position: "absolute",
        left: "20px",
        bottom: "15px",
        color: _vm.isWhiteboardOpen ? "#333" : "#ddd",
        zIndex: 10,
      },
    },
    [
      _c("i", {
        staticClass: "el-icon-info",
        style: {
          display: "inline",
          marginRight: "5px",
          fontSize: "12px",
        },
      }),
      _vm._v(" "),
      _c("span", { style: { marginRight: "15px", fontSize: "12px" } }, [
        _c("span", [_vm._v("房间号：")]),
        _vm._v("\n    " + _vm._s(_vm.channelId) + "\n  "),
      ]),
      _vm._v(" "),
      _c(
        "span",
        { style: { marginRight: "5px", fontSize: "12px", userSelect: "none" } },
        [
          _vm._v(
            "\n    剩余时间：\n    " +
              _vm._s(_vm.mins > 0 ? `${_vm.mins}分钟` : "") +
              "\n    " +
              _vm._s(_vm.seconds) +
              " 秒\n  "
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/MeetingInfo.vue?vue&type=template&id=febaac92&scoped=true&
// module id = null
// module chunks = 